import React, { Component } from 'react';
import './TmsExperienceStyles.css'
// let dummy = []


class TmsExperience extends Component {
    constructor(props) {
        super(props)

        this.state = {
            experience: []
        }
    }


    // componentWillReceiveProps(incomingData) {
    //     experience = incomingData.methodDetails.shipment_tracking_method
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // experience = nextProps.methodDetails.shipment_tracking_method
        return {
            experience: nextProps.transporter_data.tms_experience
        }
    }

    calculateTotalYears = () => {
        if (!this.state.experience || this.state.experience.length === 0) {
          return 0;
        }
        return this.state.experience.reduce((total, tms) => {
          const parsedYears = parseInt(tms.years, 10);
          if (!isNaN(parsedYears)) {
            return total + parsedYears;
          }
          return total;
        }, 0);
    };

    render() {
        const totalYears = this.calculateTotalYears();
        return (
            <div>
                <h3 className="data_header">Experience using TMS : {totalYears} year(s)</h3>
                {/* <h3 className="data_header">Experience using TMS</h3> */}
                {/* <div className='overflow-auto'>
                <table id="methods" className='table table-bordered'>
                    <thead>
                        <tr>
                            <th className='table-1'>Sr. No.</th>
                            <th className='table-2'>Name</th>
                            <th className='table-3'>Years of Experience</th>
                        </tr>
                    </thead>
                    {
                        (this.state.experience === null || this.state.experience === undefined || this.state.experience.length === 0) ? (
                            <tbody>
                                <tr>
                                    <td colSpan="4">
                                        Details not available
                                    </td>
                                </tr>
                            </tbody>
                        ) : (<tbody>
                            {this.state.experience.map((Tms, index) =>
                                <tr key={index}>

                                    <td className="table-1"> {index + 1} </td>
                                    <td className="table-2">  {Tms.service_providers} </td>
                                    <td className="table-3">  {Tms.years} </td>
                                </tr>
                            )}
                        </tbody>

                        )
                    }
                </table>
                </div> */}
            </div>
        )
    }
}

export default TmsExperience
